/**
 * Parse domain out of window location without any sub domains.
 * @returns {string}
 */
export function domainParser() {
  let segments = window.location.hostname.split('.')
  if (segments.length >= 3) {
    segments = segments.slice(1)
  }
  return '.' + segments.join('.')
}

/**
 * Parse sub domain from window location.
 * @returns {string}
 */
export function subDomainParser() {
  let segments = window.location.hostname.split('.')
  return segments[0]
}